module.exports = __webpack_public_path__ + "static/media/Harbor_1.29da957d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/outskirts/harbor/Harbor_1.png
// module id = 1315
// module chunks = 3